import React from "react";
import { Card } from "react-bootstrap";
import { useHistory } from "react-router-dom";

import { NoRecordCard, ProjectAvatar } from "../../../common/components";
import { Table } from "../../../common/components/core";
import { ProjectStateWithTxn } from "../../../types/project";
import { AmountFormatter } from "../../../utils/amount";
import { getNameInitial } from "../../../utils/common";
import {Icon} from "@blueprint/ui";

type ProjectAccountListProps = {
    projects: ProjectStateWithTxn[];
};

const ProjectAccountList = ({
    projects,
}: ProjectAccountListProps): JSX.Element => {
    const history = useHistory();
    const sortedProjects = [...projects].sort((a, b) =>
        a.state.name?.localeCompare(b.state.name),
    );

    return sortedProjects.length === 0 ? (
        <NoRecordCard />
    ) : (
        <Card className="mt-3 border-0">
            <Card.Body className="p-0">
                <table className={'custom-table'}>
                    <thead>
                        <tr>
                            <Table.HeaderCell width={200}>
                                Project Name
                            </Table.HeaderCell>
                            <Table.HeaderCell width={100}>
                                Project ID
                            </Table.HeaderCell>
                            <Table.HeaderCell
                                width={200}
                                className="text-center"
                            >
                                Bank Account
                            </Table.HeaderCell>
                            <Table.HeaderCell
                                width={200}
                                className="text-center"
                            >
                                Number of Payment Transactions
                            </Table.HeaderCell>
                            <Table.HeaderCell width={150} className="text-end">
                                Total Amount
                            </Table.HeaderCell>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedProjects.map((project) => {
                            return (
                                <Table.BodyRow
                                    key={project.state.referenceId}
                                    onClick={() =>
                                        history.push(
                                            `/collection/project/${project.state.referenceId}`,
                                        )
                                    }
                                    onKeyUp={(event:KeyboardEvent) =>
                                        {(event.keyCode === 13 || event.keyCode === 32) &&
                                            history.push(
                                                `/collection/project/${project.state.referenceId}`,
                                            )
                                        }
                                    }
                                >
                                    <td className="d-flex p-1 align-items-center">
                                        <ProjectAvatar variant="small">
                                            {getNameInitial(
                                                project.state.name,
                                            )}
                                        </ProjectAvatar>
                                        <div className="flex-grow-1 mb-0 ms-3">{project.state.name}</div>
                                    </td>
                                    <td>{project.state.externalProjectId}</td>
                                    <td className="text-center">
                                        {project.state.bankAccountRefs
                                            .length > 0 && (
                                            <Icon margin="0" name={'StatusConfirmationLight'} />
                                        )}
                                    </td>
                                    <td className="text-center">
                                        {project.trxnCount}
                                    </td>
                                    <td className="text-end">
                                        {AmountFormatter.format(
                                            project.totalAmount,
                                        )}{" "}
                                        SGD
                                    </td>
                                </Table.BodyRow>
                            );
                        })}
                    </tbody>
                </table>
            </Card.Body>
        </Card>
    );
};

export default ProjectAccountList;
